import { render, staticRenderFns } from "./PassportForm.vue?vue&type=template&id=2e61d228&"
import script from "./PassportForm.vue?vue&type=script&lang=js&"
export * from "./PassportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports